const dashboard = {
    en: {
        "dashboard.title": "Dashboard",
        "dashboard.welcome": "Welcome back",
        "dashboard.vehicles": "Vehicles",
        "dashboard.containers": "Containers",
        "dashboard.bookings": "Bookings",
        "dashboard.boats": "Boats",
        "dashboard.users": "Users",
        "dashboard.openTickets": "Open Tickets",
        "dashboard.finance": "Finance",
        "dashboard.incomeThisMonth": "Income this month",
        "dashboard.pendingBalance": "Pending balance requests",
        "dashboard.financingOutstanding": "Financing outstanding",
        "dashboard.customsFines": "Customs fines accrued",
        "dashboard.outstandingDebt": "Outstanding debt",
        "dashboard.collected": "Collected",
        "dashboard.unpaidVehicles": "unpaid vehicles",
        "dashboard.percentCollected": "collected",
        "dashboard.vehiclesByStatus": "Vehicles by status",
        "dashboard.recentVehicles": "Recent vehicles",
        "dashboard.noVehicles": "No vehicles yet",
        "dashboard.thVehicle": "Vehicle",
        "dashboard.thVin": "VIN",
        "dashboard.thStatus": "Status",
        "dashboard.thAdded": "Added",
    },
    ru: {
        "dashboard.title": "Панель управления",
        "dashboard.welcome": "С возвращением",
        "dashboard.vehicles": "Автомобили",
        "dashboard.containers": "Контейнеры",
        "dashboard.bookings": "Бронирования",
        "dashboard.boats": "Суда",
        "dashboard.users": "Пользователи",
        "dashboard.openTickets": "Открытые тикеты",
        "dashboard.finance": "Финансы",
        "dashboard.incomeThisMonth": "Доход за месяц",
        "dashboard.pendingBalance": "Запросы баланса в ожидании",
        "dashboard.financingOutstanding": "Остаток финансирования",
        "dashboard.customsFines": "Начислено штрафов",
        "dashboard.outstandingDebt": "Непогашенный долг",
        "dashboard.collected": "Собрано",
        "dashboard.unpaidVehicles": "неоплаченных авто",
        "dashboard.percentCollected": "собрано",
        "dashboard.vehiclesByStatus": "Автомобили по статусу",
        "dashboard.recentVehicles": "Последние автомобили",
        "dashboard.noVehicles": "Автомобилей пока нет",
        "dashboard.thVehicle": "Автомобиль",
        "dashboard.thVin": "VIN",
        "dashboard.thStatus": "Статус",
        "dashboard.thAdded": "Добавлено",
    },
    geo: {
        "dashboard.title": "მთავარი გვერდი",
        "dashboard.welcome": "კეთილი იყოს თქვენი დაბრუნება",
        "dashboard.vehicles": "ავტომობილები",
        "dashboard.containers": "კონტეინერები",
        "dashboard.bookings": "ჯავშნები",
        "dashboard.boats": "გემები",
        "dashboard.users": "მომხმარებლები",
        "dashboard.openTickets": "ღია ტიკეტები",
        "dashboard.finance": "ფინანსები",
        "dashboard.incomeThisMonth": "შემოსავალი ამ თვეში",
        "dashboard.pendingBalance": "ბალანსის მოთხოვნები მოლოდინში",
        "dashboard.financingOutstanding": "დაფინანსების ნაშთი",
        "dashboard.customsFines": "დარიცხული ჯარიმები",
        "dashboard.outstandingDebt": "დარჩენილი დავალიანება",
        "dashboard.collected": "ამოღებული",
        "dashboard.unpaidVehicles": "გადაუხდელი ავტომობილი",
        "dashboard.percentCollected": "ამოღებული",
        "dashboard.vehiclesByStatus": "ავტომობილები სტატუსის მიხედვით",
        "dashboard.recentVehicles": "ბოლო ავტომობილები",
        "dashboard.noVehicles": "ავტომობილები ჯერ არ არის",
        "dashboard.thVehicle": "ავტომობილი",
        "dashboard.thVin": "VIN",
        "dashboard.thStatus": "სტატუსი",
        "dashboard.thAdded": "დამატებულია",
    },
};

export default dashboard;
